import React, { useContext, useState } from 'react';

import { usePathname, useUnstableGlobalHref } from 'expo-router';

import { IBaseProps } from '@rbi-ctg/frontend';
import { usePriorValue } from 'hooks/use-prior-value';
import { useMemoAll } from 'utils/use-memo-all';

import { ILocation } from '../types';

/**
 * Useful for preventing re-renders for analytics/loggers etc. that care about routes but not real-time
 * DO NOT USE FOR RENDER-TIME LOCATION INFO as this will not trigger re-renders
 */
export const staticLocation: { current: { pathname: string; pathAndSearch: string } } = {
  // should be set very quick at app start but just in case...
  current: { pathname: '', pathAndSearch: '' },
};

export const staticReferrerLocation: { current: string | undefined } = {
  // should be set very quick at app start but just in case...
  current: '/',
};

export const LocationContext = React.createContext<ILocation>({} as ILocation);
export const useLocationContext = () => useContext(LocationContext);

export function LocationProvider(props: IBaseProps) {
  const [signUpEmail, setSignUpEmail] = useState<string>('');

  const pathAndSearch = useUnstableGlobalHref();
  const pathname = usePathname();
  staticLocation.current.pathname = pathname;
  staticLocation.current.pathAndSearch = pathAndSearch;

  const referrerLocation = usePriorValue(pathAndSearch, undefined);
  staticReferrerLocation.current = referrerLocation;

  const value: ILocation = useMemoAll({
    signUpEmail,
    setSignUpEmail,
  });

  return <LocationContext.Provider value={value}>{props.children}</LocationContext.Provider>;
}

export const LocationConsumer = LocationContext.Consumer;
